// Keep return navigation in the URL, so refreshes and new tabs preserve context.
const workflow = {
  products: 'products', productsCheckoutLinks: 'products', create_product: 'products', edit_product: 'products', create_bump: 'products', edit_bump: 'products',
  funnel_resources: 'resources', funnel_resource_assets: 'resources',
  coupons: 'coupons', create_coupon: 'coupons', edit_coupon: 'coupons',
  vendor_report: 'sales', affiliates_performance: 'performance', affiliates: 'affiliates', leader_boards: 'leaderboards',
};
export function fromFunnelStudio(destination, funnelId) {
  return { ...destination, query: { ...destination.query, studio_funnel: String(funnelId) } };
}
export function funnelStudioReturn(route) {
  const id = route.query && route.query.studio_funnel;
  if (!workflow[route.name] || typeof id !== 'string' || !/^[1-9]\d*$/.test(id)) return null;
  if (route.params && route.params.id && String(route.params.id) !== id) return null;
  return { name: 'funnelDashboard', params: { id } };
}
export function retainFunnelStudioContext(to, from) {
  const origin = funnelStudioReturn(from);
  if (!origin || !workflow[to.name] || workflow[to.name] !== workflow[from.name]) return null;
  // An explicit marker (including clearing it) takes precedence over inheritance.
  if (Object.prototype.hasOwnProperty.call(to.query || {}, 'studio_funnel')) return null;
  const candidate = fromFunnelStudio(to, origin.params.id);
  if (!funnelStudioReturn(candidate)) return null;
  return { name:to.name, params:to.params, query:candidate.query, hash:to.hash };
}
